import {Booking, MeetingRoomBooking} from "../../../API";
import React, {useCallback} from "react";
import {gql, useMutation} from "@apollo/client";
import {MeetingRoomBookings} from "../../../types/MeetingRoomBookingType";
import {SeatPaper} from "./SeatPaper";
import {MeetingRoomPaper} from "./MeetingRoomPaper";
import {ExecuteOtherBookingsButton} from "./ExecuteOtherBookingsButton";
import {BookingType} from "../../../types/BookingType";
import {useTranslation} from "react-i18next";
import {deleteSecureMeetingRoomBooking, deleteSmaxReservation} from "../../../graphql/mutations";
import {useErrorContext} from "../../../hooks/useErrorContext";

interface Props {
    position: React.CSSProperties
    offset: number
    isTimeActive: boolean
    deletableSeatBookings: Booking[]
    deletableMRBookings: MeetingRoomBooking[]
    handleBookOtherDateTime: () => void
    closeDeleteBookingDialog: () => void
    bookingType: BookingType,
    meetingRoomBookingProps?: MeetingRoomBookings | null
}

// TODO move somewhere else
export type IBooking = Booking | MeetingRoomBooking | undefined


const ItemClickedDialog: React.FC<Props> = (props) => {

    const {
        position,
        offset,
        isTimeActive,
        handleBookOtherDateTime,
        closeDeleteBookingDialog,
        bookingType,
        meetingRoomBookingProps,
        deletableSeatBookings,
        deletableMRBookings
    } = props;

    const {reportError} = useErrorContext();
    const [deleteMeetingRoomBookingMutation] = useMutation(gql(deleteSecureMeetingRoomBooking));
    const [deleteSmaxReservationMutation] = useMutation(gql(deleteSmaxReservation));

    const removeSelectedMRBooking = useCallback((meetingRoomBooking: MeetingRoomBooking) => {
        deleteMeetingRoomBookingMutation({
            variables: {
                input: {
                    bookingId: meetingRoomBooking.bookingId,
                    bookerId: meetingRoomBooking.bookerId,
                    orgUnitId: meetingRoomBooking.orgUnitId,
                    meetingRoomId: meetingRoomBooking.meetingRoomId,
                    roomId: meetingRoomBooking.roomId,
                    date: meetingRoomBooking.date
                }
            }
        }).then(() => {
            const smaxBooking = {
                bookingId: meetingRoomBooking.bookingId,
                date: meetingRoomBooking.date,
                meetingRoomId: meetingRoomBooking.meetingRoomId,
                roomId: meetingRoomBooking.roomId,
                bookerId: meetingRoomBooking.bookerId,
                bookerName: meetingRoomBooking.bookerName,
                bookerGivenName: meetingRoomBooking.bookerGivenName,
                bookerFamilyName: meetingRoomBooking.bookerFamilyName,
                orgUnitId: meetingRoomBooking.orgUnitId,
                timeBegin: meetingRoomBooking.timeBegin,
                timeEnd: meetingRoomBooking.timeEnd,
                meetingName: meetingRoomBooking.meetingName,
                roomCapacity: meetingRoomBooking.roomCapacity,
                participantNumber: meetingRoomBooking.participantNumber,
                meetingType: meetingRoomBooking.meetingType,
                visitors: meetingRoomBooking.visitors,
                meetingRoomSeatingConf: meetingRoomBooking.meetingRoomSeatingConf
            }
            console.log(smaxBooking);
            deleteSmaxReservationMutation({
                variables:{
                    input: {
                        meetingRoomBookings: [smaxBooking],
                        seatBookings: []
                    }
                }}).catch(err => reportError(err, "Smax Create Reservation Error"))
        })
            .catch((err) => {
            console.error("ItemClickedDialog removeSelectedMeetRoomBooking:", err);
        }).finally(closeDeleteBookingDialog)
    }, [closeDeleteBookingDialog, deleteMeetingRoomBookingMutation])


    const {t} = useTranslation();
    const getExecuteOtherBookingsButtonText = function () {
        const nameBasedOnTimeActivityForSeatPopup = isTimeActive ? t("button_book_other_days_times") : t("button_book_other_days");
        return bookingType === "meetingRoom" ? t("open_another_booking_dialog") : nameBasedOnTimeActivityForSeatPopup;
    }

    const executeOtherBookingsButton = <ExecuteOtherBookingsButton handleBookOtherDateTime={handleBookOtherDateTime}
                                                                   text={getExecuteOtherBookingsButtonText()}/>

    return (
        <>
            {(bookingType === "meetingRoom") ?
                <MeetingRoomPaper
                    deletableBookings={deletableMRBookings}
                    executeOtherBookingsButton={executeOtherBookingsButton}
                    position={position}
                    offset={offset}
                    meetingRoomBookingProps={meetingRoomBookingProps}
                    removeSelectedBooking={removeSelectedMRBooking}
                />
                :
                <SeatPaper
                    deletableBookings={deletableSeatBookings}
                    executeOtherBookingsButton={executeOtherBookingsButton}
                    position={position}
                    offset={offset}
                    isTimeActive={isTimeActive}
                    closeDeleteBookingDialog={closeDeleteBookingDialog}
                />
            }
        </>);
}

export default ItemClickedDialog





